import { appHelper, ecosystemHelper, loginHelper, teamService } from '@/main';
import { profileModule } from '@/store/modules/profile';
import { purchaseSettingsModule } from '@/store/modules/purchaseSettings';
import { settingsModule } from '@/store/modules/settings';
import { Membership } from '../models/Interfaces';

export class TeamHelper {
    public _currentTeam: Membership = null;
    public setupIsDone: boolean = false;
    public async setup() {
        if (appHelper.isInvoice()) {
            const team = this.getTeam();
            this.setTeamByTeamId(team.id);
        } else {
            let team = null;
            const urlSegments = window.location.pathname.split('/');
            if (typeof urlSegments === 'object' && urlSegments.length > 3) {
                team = parseInt(urlSegments[3].split('-')[0]);
            }

            this.setTeamByTeamId(team);
        }
        this.setupIsDone = true;
    }

    public getTeam(id?: number) {
        if (!id && this._currentTeam) {
            id = this._currentTeam.id;
        }
        const user = profileModule.brightProfile;
        let team = user.teamMemberships
            .filter((x) => x.ecosystem === ecosystemHelper.currentEcosystem.id)
            .find((membership) => {
                return membership.id === id;
            });

        if (team) {
            return team;
        }

        team = user.teamMemberships.filter((x) => x.ecosystem === ecosystemHelper.currentEcosystem.id).find((x) => x.id === user.primaryTeam);
        if (team) {
            return team;
        }

        team = user.teamMemberships.filter((x) => x.ecosystem === ecosystemHelper.currentEcosystem.id)[0];

        if (team) {
            return team;
        }

        return user.teamMemberships[0];
    }

    public setTeamByTeamId(id: number) {
        this._currentTeam = this.getTeam(id);
        // tslint:disable-next-line: no-floating-promises
        settingsModule.fetchTeamSettingsIfNeeded(this._currentTeam.id);
        // tslint:disable-next-line: no-floating-promises
        purchaseSettingsModule.fetchTeamSettingsIfNeeded(this._currentTeam.id);
    }

    public setTeam(team: Membership) {
        this.setTeamByTeamId(team.id);
    }

    public getTeamId(id?: number): any {
        const team = this.getTeam(id);
        return team.id;
    }

    public getTeamName(id: number): any {
        const user = loginHelper.getUser();
        const team = user.teamMemberships.find((membership) => {
            return membership.id === id;
        });

        if (team) {
            return team.name;
        }

        return user.teamMemberships[0].name;
    }

    public async getTeamMembers(teamId: number) {
        if (this._currentTeam.members && this._currentTeam.members.length > 0 && this._currentTeam.id === teamId) {
            return this._currentTeam.members;
        }

        const members = await teamService.getMembers(teamId);
        if (members && members.length > 0 && this._currentTeam.id === teamId) {
            this._currentTeam.members = members;
        }

        return members;
    }

    public getTeamIdByKey(key?: string) {
        if (!key) {
            key = this._currentTeam.key;
        }

        const user = loginHelper.getUser();
        const team = user.teamMemberships.find((membership) => {
            return membership.key === key;
        });

        if (team) {
            return team;
        }
        return user.teamMemberships[0];
    }

    public getLegalEntityReference(): string {
        const team = ecosystemHelper.structure.teams.find((x) => x.teamId === this.currentTeamId);
        return team.legalEntityReference;
    }

    get currentTeam(): Membership {
        if (this._currentTeam === null) {
            const team = this.getTeam();
            this._currentTeam = team;
        }

        return this._currentTeam;
    }

    get currentTeamId(): number {
        return this._currentTeam.id;
    }

    get teamParam(): string {
        return `${this._currentTeam.id}-${this.currentTeam.key}`;
    }

    get teams(): Membership[] {
        const user = loginHelper.getUser();
        return user.teamMemberships.filter((x) => x.ecosystem === this._currentTeam.ecosystem);
    }

    public getTeamByKey(key: string): Membership {
        const team = this.getTeamIdByKey(key);
        return team;
    }
}
